import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListLayout from "../../../../../components/common/List/Custom-List_layout";
import ConfirmationModal from "../../../../../components/common/List/DeletePopup";
import { useGetVendorWarehousesQuery } from "../../../../../store/api/VendorWarehouseApi";

const WarehouseList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValues, setFilterValues] = useState({});
  const [sortKey, setSortKey] = useState("created_at");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteid, setdeleteid] = useState({});
  const [pageSize, setPageSize] = useState(10);

  const { data: tabledata, isLoading, refetch } = useGetVendorWarehousesQuery({
    page: currentPage,
    page_size: pageSize,
    sort: sortKey,
    ...filterValues,
  });

  const handleDelete = async () => {
    try {
      // await deleteWarehouse(deleteid.id)
      setIsModalOpen(false);
      refetch();
    } catch (error) {
      console.error("Delete failed", error);
      refetch();
    }
  };

  const handleSort = (key) => {
    if (sortKey !== key) setSortKey(key);
  };

  useEffect(() => {
    refetch();
  }, []);


  const tableHeaders = [
    { label: "Name", key: "name", sortable: true },
    { label: "Address", key: "address", sortable: true },
    { label: "City", key: "city", sortable: true },
    { label: "State", key: "state", sortable: true },
    { label: "Postal Code", key: "postal_code" },
    { label: "Country", key: "country" },
    { label: "Contact Number", key: "contact_number" },
    {
      label: "Created At",
      key: "created_at",
      sortable: true,
      render: (value) => new Date(value).toLocaleString(),
    },
    {
      label: "Updated At",
      key: "updated_at",
      sortable: true,
      render: (value) => new Date(value).toLocaleString(),
    },
  ];

  // 🔍 Filters for searching warehouses
  const filters = [
    { key: "name", type: "text", placeholder: "Warehouse Name" },
    { key: "city", type: "text", placeholder: "City" },
    { key: "state", type: "text", placeholder: "State" },
  ];

  const filterComponents = filters.map((filter) => ({
    ...filter,
    value: filterValues[filter.key] || "",
  }));

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  // ⚙️ Action buttons for each row
  const actionButtons = [
    {
      icon: "MdOutlineRemoveRedEye",
      onClick: (row) => navigate(`/warehouse-view/${row.id}/`, { state: { pageName: "WAREHOUSE" } }),
    },
    {
      icon: "MdOutlineModeEdit",
      onClick: (row) => navigate(`/edit-warehouse/${row.id}/`, { state: { pageName: "WAREHOUSE" } }),
    },
    {
      icon: "RiDeleteBinLine",
      onClick: (row) => {
        setdeleteid(row);
        setIsModalOpen(true);
      },
    },
  ];

  // ➕ Add button
  const Buttons = [
    {
      title: "+ Add Warehouse",
      design:
        "px-2 text-base py-1.5 bg-secondary font-normal text-white rounded hover:bg-secondary-700 flex items-center gap-1",
      onClick: () => navigate("/warehouse-create", { state: { pageName: "Create Warehouse" } }),
    },
  ];

  // 🧩 Handle both array and paginated API responses
  const tableDataArray = Array.isArray(tabledata)
    ? tabledata
    : tabledata?.results || [];

  const totalRecords = Array.isArray(tabledata)
    ? tabledata.length
    : tabledata?.count;

  useEffect(() => {
    console.log("Warehouse API Data:", tabledata);
  }, [tabledata]);

  return (
    <>
      <ListLayout
        title="Warehouse List"
        Buttons={Buttons}
        filterComponents={filterComponents}
        onFilterChange={handleFilterChange}
        tableHeaders={tableHeaders}
        tabledata={tableDataArray}
        actionButtons={actionButtons}
        currentPage={currentPage}
        totalrecords={totalRecords}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSort={handleSort}
        sortKey={sortKey}
        isLoading={isLoading}
      />

      {isModalOpen && (
        <ConfirmationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};

export default WarehouseList;
